import React, { useState } from "react";
import "./CancionesComponent.css";
import canciones from "./cancionesData";

const CancionesComponent = () => {
  const [selectedSongIndex, setSelectedSongIndex] = useState(null);
  const [fadeIn, setFadeIn] = useState(false);

  const handleSongClick = (index) => {
    console.log("Canción seleccionada:", index);
    if (selectedSongIndex !== index) {
      setFadeIn(false); // Reinicia el efecto
      setTimeout(() => {
        setSelectedSongIndex(index);
        setFadeIn(true); // Activa el efecto de fade-in
        console.log("Fade-in aplicado:", fadeIn);
      }, 100); // Le damos un pequeño retraso
    }
  };

  return (
    <div className="canciones-container">
      <div className="canciones-header">
        <h1 className="titulo-page">Canciones Rodrigueras</h1>
        <p className="canciones-note">
          <em>
            Nota: Los autores no se hacen responsables de los efectos
            secundarios que produzcan cantar estas canciones.
          </em>
        </p>
        <div className="canciones-warning">
          <span>- LEA ATENTAMENTE EL CONTENIDO DE ESTAS CANCIONES</span>
          <span>- ANTE CUALQUIER DUDA CONSULTE CON SU FARMACÉUTICO</span>
        </div>
      </div>
      <div className="canciones-main">
        <div className="canciones-list-container">
          <ul className="canciones-list">
            {canciones.map((cancion, index) => (
              <li key={index} className="cancion-item">
                <a
                  href="#"
                  className={`cancion-link ${
                    selectedSongIndex === index ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSongClick(index);
                  }}
                >
                  {cancion.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="cancion-content-container">
          {selectedSongIndex !== null ? (
            <div className="cancion-content">
              <h2>{canciones[selectedSongIndex].title}</h2>
              <div
                className={`cancion-lyrics ${
                  fadeIn ? "fade-in-text" : ""
                }`}
              >
                {canciones[selectedSongIndex].lyrics}
              </div>
            </div>
          ) : (
            <p className="placeholder">
              Selecciona una canción para ver la letra.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CancionesComponent;
